<template>
  <el-form-item v-bind="$attrs" v-on="$listeners" :prop="(!validate || isReadOnly || disabled) ? '' : prop">
    <div v-if="isReadOnly" class="value">
      <div style="display: inline" v-if="showValue !== null">{{showValue}}</div>
      <div style="display: inline" v-else-if="model[prop] !== null && model[prop] !== ''"
           v-loading="loading">{{model[prop] | valueName(className)}}
      </div>
      <div  v-else style="display: inline; color: darkgrey; font-weight: bold">{{emptyValue}}</div>
      {{$attrs['suffix']}}
    </div>
    <slot v-else>
    </slot>
  </el-form-item>
</template>

<script>
  export default {
    name: 'FormItem',
    props: {
      readOnly: {
        type: Boolean,
        default: null
      },
      showValue: {
        type: [String, Number],
        default: null
      },
      prop: String,
      className: String,
      emptyValue: {
        type: String,
        default: '空'
      },
      disabled: Boolean,
      validate: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      isReadOnly () {
        if (this.readOnly !== null) return this.readOnly
        let parent = this.$parent
        while (parent) {
          if (parent.controlReadOnly != null) return parent.controlReadOnly
          parent = parent.$parent
        }
        return null
      },
      model () {
        let parent = this.$parent
        while (parent) {
          if (parent.model != null) return parent.model
          parent = parent.$parent
        }
        return null
      },
      loading () {
        if (!this.className) return false
        switch (this.className) {
          case 'Date':
          case 'Datetime':
            return false
        }
        return this.$isLoading(this.className)
      }
    }
  }
</script>

<style scoped>

</style>
